module.exports = __webpack_public_path__ + "img/gemini-dark.d0658593.png";